module.exports = __webpack_public_path__ + "static/media/dp-placeholder.eba2767d.png";